<div class="container-fluid">

    <h4 id="upper"> Vendeurs /Marketplace </h4>
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div>
                        <!--  -->
                        <div class="d-flex align-items-center gap-3 flex-wrap">
                            <label for="categorie" class="form-label">Rechercher</label>
                            <div>
                                <label class="d-inline-flex align-items-center">
                                    <input title="Rechercher par nom, prénom, email ou téléphone" type="text"
                                        [(ngModel)]="searchTerm" (input)="filterBySearchTerm()" class="form-control"
                                        id="searchMembre" placeholder="" />

                                </label>
                            </div>


                        </div>


                    </div>
                    <div class="row mb-md-2">


                        <!-- End search -->
                    </div>
                    <div class="table-responsive">
                        <table class="table text-nowrap align-middle mb-0">
                            <thead>
                                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                                    style="border-color: #578D63;">
                                    <th scope="col" class="ps-0">Nom</th>
                                    <th scope="col">Prénom</th>
                                    <th scope="col">Email</th>

                                    <th scope="col" class="text-center">Statut</th>
                                    <th scope="col" colspan="3" class="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody class="table-group-divider">
                                <tr *ngFor="let item of paginatedItems"
                                    [ngClass]="{'table-danger': item?.statut === 'suspens'}">
                                    <th scope="row" class="ps-0 fw-medium">
                                        <span class="table-link1 text-truncate d-block">{{ item?.nom }} &nbsp;</span>
                                    </th>
                                    <td>
                                        <span class="table-link1 text-truncate d-block">{{ item?.prenom }}</span>
                                    </td>
                                    <td class="text-center fw-medium">
                                        <span class="table-link1 text-truncate d-block">{{ item?.email || "-"}} &nbsp;</span>
                                    </td>
                                    <td class="text-center fw-medium">
                                        <span class="table-link1 text-truncate d-block">
                                            {{ getLibelleStatut(item?.vendeur_status) }}
                                        </span>
                                    </td>
                                    <td>
                                        <!-- Modifier (toujours disponible) -->

                                        <!-- Valider (uniquement si en attente) -->

                                        <a (click)="getInfo(item)" style="cursor: pointer;"
                                            class="me-3 text-primary"
                                            title="Cliquez ici pour valider un vendeur">
                                            <i class="pi pi-info-circle" style="font-size: 1rem"></i>
                                        </a>
                                        <a *ngIf="item.vendeur_status==='pending'" (click)="validateVendeur(item)"
                                            style="cursor: pointer;" class="me-3 text-success"
                                            title="Cliquez ici pour valider un vendeur">
                                            <i class="pi pi-check-circle" style="font-size: 1rem"></i>
                                        </a>

                                        <!-- Suspendre (uniquement si actif) -->
                                        <a *ngIf="item.vendeur_status==='valide'" (click)="prepareSuspend(item)"
                                            style="cursor: pointer;" class="me-3 text-danger"
                                            title="Cliquez ici pour suspendre un vendeur">
                                            <i class="pi pi-times-circle" style="font-size: 1rem"></i>
                                        </a>

                                        <!-- Réactiver (uniquement si suspendu) -->
                                        <a *ngIf="item.vendeur_status==='suspens'" (click)="reactiverVendeur(item)"
                                            style="cursor: pointer;" class="me-3 text-warning"
                                            title="Cliquez ici pour réactiver un vendeur">
                                            <i class="pi pi-refresh" style="font-size: 1rem"></i>
                                        </a>
                                        <a *ngIf="item.vendeur_status==='pending'" style="cursor: pointer;"
                                            (click)="prepareReject(item)" class="me-3 text-danger" title="Rejeter">
                                            <i class="pi pi-times" style="font-size:1rem"></i>
                                        </a>
                                        <!-- Supprimer (toujours disponible) -->
                                        <!-- <a (click)="confirmSuppression(item)" href="javascript:void(0);"
                                            class="text-danger" title="Cliquez ici pour retirer un administrateur">
                                            <i class="mdi mdi-trash-can font-size-18"></i>
                                        </a> -->
                                    </td>

                                </tr>

                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="d-flex justify-content-center" *ngIf="isLoading === true">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Chargement en cours...</h5>
                                <div class="loader4"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
                    <div class="container">
                        <div class="row">
                            <div class="text-center">
                                <h5 id="graycolor">Aucune donnée trouvée</h5>
                            </div>
                        </div>
                    </div>

                </div>
                <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
                    [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
            </div>
        </div>
    </div>


</div>



<p-dialog header="Motif de suspension" [modal]="true" [(visible)]="displaySuspendDialog" [style]="{ width: '25rem' }">
    <div class="d-flex flex-column align-items-center">
        <div class="col-12 col-md-8 text-center">
            <textarea class="form-control" id="reason" rows="4" cols="30" [(ngModel)]="suspendReason" required
                placeholder="Entrez le motif de suspension"></textarea>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="Enregistrer" (click)="suspendVendeur()" />
    </div>
</p-dialog>

<p-dialog header="Motif de rejet" [modal]="true" [(visible)]="displayRejectDialog" [style]="{ width: '25rem' }">
    <div class="d-flex flex-column align-items-center">
        <div class="col-12 col-md-8 text-center">
            <textarea class="form-control" id="reason" rows="4" cols="30" [(ngModel)]="rejectReason" required
                placeholder="Entrez le motif de rejet"></textarea>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="Enregistrer" (click)="onConfirmReject()" />
    </div>
</p-dialog>

<ng-template #infoModal let-modal>
  <div class="modal-header modern-header">
    <div class="d-flex align-items-center w-100">
      <div class="user-avatar me-3">
        <div class="avatar-circle" [ngClass]="avatarColorClass">
          {{ getInitials() }}
        </div>
      </div>
      <div class="flex-grow-1">
        <h5 class="modal-title mb-1">
          <i class="bi bi-person-badge me-2"></i>
          Information du vendeurs
        </h5>
        <p class="mb-0 text-muted small">
          <i class="bi bi-person-circle me-1"></i>
          ID: {{ infoVendeurItems?.id }}
        </p>
      </div>
      <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Fermer"></button>
    </div>
  </div>

  <div class="modal-body modern-body">
    <!-- Bannière statut -->
    <div class="status-banner mb-4" [ngClass]="statusBannerClass">
      <div class="d-flex align-items-center">
        <i class="bi status-icon me-2" [ngClass]="statusIconClass"></i>
        <div>
          <strong class="d-block">Statut: {{ infoVendeurItems?.statut | titlecase }}</strong>
          <small class="d-block">{{ getStatusDescription() }}</small>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <!-- -------- COLONNE GAUCHE -------- -->
      <div class="col-md-6">
        <!-- IDENTITÉ -->
        <div class="card-section">
          <div class="section-header">
            <i class="bi bi-person section-icon"></i>
            <h6 class="section-title">Identité</h6>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Nom complet</span>
              <span class="info-value">{{ infoVendeurItems?.prenom }} {{ infoVendeurItems?.nom }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Sexe</span>
              <span class="info-value badge gender-badge">{{ infoVendeurItems?.sexe }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Situation matrimoniale</span>
              <span class="info-value">{{ infoVendeurItems?.situation_matrimonial | titlecase }}</span>
            </div>
          </div>
        </div>

        <!-- CONTACT -->
        <div class="card-section">
          <div class="section-header">
            <i class="bi bi-telephone section-icon"></i>
            <h6 class="section-title">Contact</h6>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Téléphone</span>
              <a href="tel:{{ infoVendeurItems?.telephone }}" class="info-value link-value">
                <i class="bi bi-telephone-outbound me-1"></i>
                {{ infoVendeurItems?.telephone }}
              </a>
            </div>
            <div class="info-item">
              <span class="info-label">Email</span>
              <a href="mailto:{{ infoVendeurItems?.email }}" class="info-value link-value">
                <i class="bi bi-envelope me-1"></i>
                {{ infoVendeurItems?.email }}
              </a>
            </div>
            <div class="info-item">
              <span class="info-label">Email vérifié</span>
              <span class="info-value">
                <i class="bi" [ngClass]="infoVendeurItems?.email_verified_at ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'"></i>
                {{ infoVendeurItems?.email_verified_at ? 'Oui' : 'Non' }}
              </span>
            </div>
          </div>
        </div>

        <!-- ROLES -->
        <div class="card-section">
          <div class="section-header">
            <i class="bi bi-people section-icon"></i>
            <h6 class="section-title">Rôles & Permissions</h6>
          </div>
          <div class="roles-container">
            <div *ngFor="let role of infoVendeurItems?.roles" class="role-badge">
              <i class="bi bi-shield-check me-1"></i>
              {{ role.libelle }}
            </div>
          </div>
        </div>
      </div>

      <!-- -------- COLONNE DROITE -------- -->
      <div class="col-md-6">
        <!-- LOCALISATION -->
        <div class="card-section">
          <div class="section-header">
            <i class="bi bi-geo-alt section-icon"></i>
            <h6 class="section-title">Localisation</h6>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Ville</span>
              <span class="info-value">
                <i class="bi bi-geo me-1"></i>
                {{ infoVendeurItems?.ville?.name }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Pays</span>
              <span class="info-value">
                <i class="bi bi-flag me-1"></i>
                {{ infoVendeurItems?.ville?.country?.name }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Code pays</span>
              <span class="info-value badge country-code">
                {{ infoVendeurItems?.ville?.country?.country_code }}
              </span>
            </div>
          </div>
        </div>

        <!-- DATES -->
        <div class="card-section">
          <div class="section-header">
            <i class="bi bi-clock-history section-icon"></i>
            <h6 class="section-title">Historique</h6>
          </div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Créé le</span>
              <span class="info-value">
                <i class="bi bi-calendar-plus me-1"></i>
                {{ infoVendeurItems?.created_at | date:'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Mis à jour le</span>
              <span class="info-value">
                <i class="bi bi-calendar-check me-1"></i>
                {{ infoVendeurItems?.updated_at | date:'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">Dernière connexion</span>
              <span class="info-value">
                <i class="bi bi-clock me-1"></i>
                {{ infoVendeurItems?.derniere_connexion ? (infoVendeurItems?.derniere_connexion | date:'dd/MM/yyyy HH:mm') : 'Aucune' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer modern-footer">
    <button class="btn btn-outline-secondary me-2" (click)="modal.close()">
      <i class="bi bi-x-lg me-1"></i>
      Fermer
    </button>
   
  </div>
</ng-template>


<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>